export function hasBurmeseCharacters(inputString) {
  const burmeseRegex = /[\u1000-\u109F\uAA60-\uAA7F\uA9E0-\uA9FF]+/;

  return burmeseRegex.test(inputString);
}

export function isValidKey(obj, key) {
  return obj.hasOwnProperty(key);
}
